import { AuthenticatedUserResponseDto } from '@monksflow/platform-api-sdk';

interface Environment {
  PLATFORM_API_BASE_URL: string;
  PLATFORM_BASE_URL: string;
  PERSONA_API_BASE_URL: string;
  ENABLE_LOCAL_TESTING_AUTHENTICATION: boolean;
  LOCAL_TOKEN?: string;
  LOCAL_USER?: AuthenticatedUserResponseDto | null;
  USE_MOCK_SERVER: boolean;
  ASSETS_API_BASE_URL: string;
  INFERENCE_ENGINE_API_BASE_URL: string;
  GUIDELINES_API_BASE_URL: string;
  WORKSPACE_API_BASE_URL: string;
  MEDIA_API_BASE_URL: string;
  CONTENT_STUDIO_API_BASE_URL: string;
  REELS_API_BASE_URL: string;
}

// Parse boolean from string env var (Vite env vars are always strings)
const useDevAuth = import.meta.env.ENABLE_LOCAL_TESTING_AUTHENTICATION === 'true';

let parsedUser: AuthenticatedUserResponseDto | null = null;

if (useDevAuth) {
  // Runtime validation: these are required when dev auth is enabled
  if (!import.meta.env.LOCAL_TOKEN) {
    throw new Error(
      'Invalid configuration - if dev auth is enabled, LOCAL_TOKEN env variable must be set',
    );
  }

  if (!import.meta.env.LOCAL_USER) {
    throw new Error(
      'Invalid configuration - if dev auth is enabled, a LOCAL_USER must be set. See README for instructions',
    );
  }

  // Safe to parse: we've validated it exists above
  // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
  parsedUser = JSON.parse(import.meta.env.LOCAL_USER);
}

// values that were parsed from the string representation coming on the env variable
const parsedValues = {
  LOCAL_USER: parsedUser,
  ENABLE_LOCAL_TESTING_AUTHENTICATION: useDevAuth,
  USE_MOCK_SERVER: import.meta.env.USE_MOCK_SERVER === 'true',
};

// Merge env vars with parsed values, asserting the result matches our Environment interface
export const ENV = { ...import.meta.env, ...parsedValues } as Environment;
